module.exports = __webpack_public_path__ + "img/cwell5.52c4956d.jpg";